import React from "react";
import { useDispatch } from "react-redux";
import { Box, Grid, Link, Divider, Typography, Theme } from "@mui/material";
// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";
import { useFormik } from "formik";
import { searchDataWithGet, AddData } from "src/app-redux/common-actions";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { ISchedulingItem } from "src/common/typings/scheduling";
import { getUTCDateTime, setDateTimeFormate } from "src/common/utils/app.util";
import { useMyWinHeightContext } from "src/common/utils/getWindowDimensions";
import { moneyformatter, stringFormate } from "src/common/utils/helpers";
import AlertDialog from "src/components/AlertDialog/AlertDialog";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import CommonTextEditor from "src/components/CommonTextEditor/CommonTextEditor";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import CommonXGrid from "src/components/CommonXGrid/CommonXGrid";
import { Sticky } from "./stickyinfo";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heading: {
      fontSize: theme.typography.pxToRem(17),
      color: "#000",
      lineHeight: "28px",
    },
  })
);

export default function SchedulingList() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { winHeight } = useMyWinHeightContext();
  const [loader, setLoader] = React.useState(false);
  const [gData, setgData] = React.useState<ISchedulingItem[]>([]);
  const [drawerStatus, setdrawerStatus] = React.useState<boolean>(false);
  const [drawerStatus2, setdrawerStatus2] = React.useState<boolean>(false);
  const [selectedData, setSelectedData] = React.useState<any>({});
  const [dataComments, setDataComments] = React.useState<any>("");
  const [alertDialog, setAlertDialog] = React.useState(false);
  const columns = [
    {
      field: "poNum",
      headerName: "PO #",
      type: "string",
      width: 150,
      renderCell: function customCell1(params: any) {
        return (
          <Link
            component="button"
            variant="body2"
            onClick={() => {
              if (params.row.serviceDays > 1) {
                dispatch(
                  addNotificationAction({
                    message: "You are not allowed to schedule due to service days constrains.",
                    options: { variant: "warning" },
                  })
                );
              } else {
                isDrawerOpen(params.row);
              }
            }}
          >
            {params.value}
          </Link>
        );
      },
    },
    {
      field: "task",
      headerName: "Order Type",
      type: "string",
      width: 150,
      renderCell: function customCell1(params: any) {
        return (
          <Link
            component="button"
            variant="body2"
            onClick={() => {
              isDrawerOpen2(params.row);
            }}
          >
            {params.value}
          </Link>
        );
      },
    },
    {
      field: "range",
      headerName: "Service Range",
      type: "string",
      width: 200,
      //isDateField: true,
    },
    {
      field: "nte",
      headerName: "NTE",
      type: "number",
      width: 150,
      valueFormatter: (params: any) => {
        if (!params.value) {
          return params.value;
        }
        return moneyformatter(params.value);
      },
    },
    {
      field: "cleintCode",
      headerName: "Client Code",
      type: "string",
      width: 150,
    },
    {
      field: "loc",
      headerName: "Store Number",
      type: "string",
      width: 150,
    },
    {
      field: "city_state",
      headerName: "City, State",
      type: "string",
      width: 160,
    },
    {
      field: "zipCode",
      headerName: "Zip Code",
      type: "string",
      width: 120,
    },
    {
      field: "address",
      headerName: "Address",
      type: "string",
      width: 150,
    },
    {
      field: "phone",
      headerName: "Phone #",
      type: "string",
      width: 150,
      renderCell: function customCell(params: any) {
        return (
          <Link
            component="button"
            variant="body2"
            onClick={(e: any) => {
              e.preventDefault();
              e.stopPropagation();
              window.open(`tel:${params.value}`, "_self");
              return false;
            }}
          >
            {params.value}
          </Link>
        );
      },
    },
    {
      field: "status",
      headerName: "WO Status",
      type: "string",
      width: 180,
    },
  ];
  React.useEffect(() => {
    handleSearch();
  }, []);

  const formik = useFormik({
    initialValues: {
      ocdId: null,
      ordNum: null,
      visitDate: "",
      comment: "",
    },
    onSubmit: async (values) => {
      const clone = JSON.parse(JSON.stringify(values));
      clone.ocdId = selectedData.ocdId;
      clone.ordNum = parseInt(selectedData.ordNum || "0");
      //clone.visitDate = getUTCDateTime(values.visitDate); im removing utc logic as QA said
      setLoader(true);
      try {
        await dispatch(
          AddData(
            "/update-order-crew-detail-visit-date",
            "VisitDate added successfully",
            JSON.stringify(clone)
          )
        );
      } catch (error) {
        setLoader(false);
      }
      setLoader(false);
      setdrawerStatus(false);
      formik.resetForm();
      handleSearch();
    },
  });
  const handleSearch = async () => {
    setgData([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchDataWithGet("/get-orders-for-scheduling-by-vend-num")
      );
      if (results?.ordersScheduling) {
        const transformedData = results.ordersScheduling.map((invoice: ISchedulingItem) => {
          const rangst = setDateTimeFormate(invoice.beginService, "MM/DD/YYYY") || "";
          const rangEd = setDateTimeFormate(invoice.serviceEnd, "MM/DD/YYYY") || "";
          let conbine = invoice.city;
          if (conbine && invoice.state) conbine = `${conbine}, ${invoice.state}`;
          else if (invoice.state) conbine = invoice.state;
          return {
            ...invoice,
            id: invoice.ocdId,
            range: `${rangst} - ${rangEd}`,
            city_state: conbine,
          };
        });
        setgData(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }

    setLoader(false);
  };

  const isDrawerOpen = (parms: any) => {
    setSelectedData(parms);
    setdrawerStatus(true);
    formik.resetForm();
  };
  const isDrawerOpen2 = (parms: any) => {
    setDataComments(stringFormate(parms.orderComment));
    setdrawerStatus2(true);
  };
  const checkForDateRanges = (val?: string) => {
    let result = false;
    const tim: any = getUTCDateTime(val);
    if (tim < selectedData?.beginService) {
      result = true;
    }
    if (tim > selectedData?.serviceEnd) {
      result = true;
    }
    return result;
  };
  const dppr = 1000;
  const gridMaxHeight = winHeight - 192;
  return (
    <>
      <AlertDialog
        isOpen={alertDialog}
        handleClose={() => setAlertDialog(true)}
        message={"Visit date is outside the date range of WO"}
        primaryButtonText="Ok"
        noShowCancelBtn
        onPrimaryButtonClick={() => setAlertDialog(false)}
        heading={"Warning"}
        headerColor="#eed202"
      />
      <CommonDrawer
        heading={"Scheduling"}
        isOpen={drawerStatus}
        closeDrawer={() => {
          setdrawerStatus(false);
        }}
        drawerWidth={650}
      >
        <>
          <Sticky stickyInfo={selectedData} />
          <Box mb={2} />
          <Grid item xs={12} md={12}>
            <Box mt={2}>
              <Typography className={classes.heading}>Add Visit Date</Typography>
            </Box>
          </Grid>
          <Divider />
          <Box mb={2} />
          <Grid spacing={2} container direction="row">
            <Grid item xs={12} md={12}>
              <CommonTextFieldDate
                label={"Date Time"}
                type={"datetime-local"}
                name={"visitDate"}
                required
                value={formik.values.visitDate}
                onChange={formik.handleChange}
                onBlur={(e: any) => {
                  if (checkForDateRanges(e.target.value)) {
                    setAlertDialog(true);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CommonTextEditor
                value={formik.values.comment}
                onChange={formik.handleChange}
                name={"comment"}
                height={140}
                title="Comment"
                required
                showHeader
              />
            </Grid>
            <Grid item xs={12}>
              <Box mt={2} mb={2} textAlign="right">
                <Box component="span" mr={2}>
                  <CommonButton
                    onClick={() => {
                      setdrawerStatus(false);
                    }}
                  >
                    Cancel
                  </CommonButton>
                </Box>
                <Box component="span">
                  <CommonButton
                    isGreen
                    disable={
                      !(
                        !checkForDateRanges(formik.values.visitDate) &&
                        formik.values.visitDate &&
                        formik.values.comment
                      )
                    }
                    onClick={() => {
                      formik.submitForm();
                    }}
                  >
                    Save
                  </CommonButton>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </>
      </CommonDrawer>
      <CommonDataGridPage
        module={"Scheduling"}
        heading={"List of Scheduling"}
        pageTitle="TFG | Portal | Scheduling"
        GridDataComp={
          <CommonXGrid
            rows={gData}
            columns={columns}
            loader={loader}
            height={gridMaxHeight}
            defaultPerPageRecord={dppr}
            showOnlyDate
            modifyColumns
          />
        }
      >
        <></>
      </CommonDataGridPage>
      <CommonDrawer
        heading={"Scheduling"}
        isOpen={drawerStatus2}
        closeDrawer={() => {
          setdrawerStatus2(false);
          setDataComments("");
        }}
        drawerWidth={450}
      >
        <>
          <Grid container direction="row">
            <Grid item xs={12} md={12}>
              <Box ml={0}>
                <Grid item xs={12} md={12}>
                  <Box mt={2}>
                    <Typography className={classes.heading}>Description of service</Typography>
                  </Box>
                </Grid>
                <Divider />
                <Box p={1}>
                  <Grid container direction="row">
                    <Box color="text.primary">
                      <Typography
                        component="p"
                        dangerouslySetInnerHTML={{
                          __html: dataComments,
                        }}
                      ></Typography>
                    </Box>
                  </Grid>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </>
      </CommonDrawer>
    </>
  );
}
